import {z} from 'zod'

import {CreateOrUpdateBlockDataSheetDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {stringToJSONSchema} from '../../utils/jsonSchema'
import {DataSheetForm} from '../../SharedForms/DataSheetForm/DataSheetForm'

import type {CreateOrUpdateBlockDataSheetMutation, BlockDataSheetInput, XcNwBlock_BlockDataSheetType_Fragment} from '@sdox/api'

type UpdateDataSheetValidatorSchema = z.infer<typeof updateDataSheetValidatorSchema>

const updateDataSheetValidatorSchema = z.object({
  data: z.object({
    rawItems: stringToJSONSchema.pipe(z.array(z.object({}).passthrough())),
    config: stringToJSONSchema.pipe(z.object({}).passthrough()),
    sections: stringToJSONSchema.pipe(z.array(z.object({}).passthrough())),
  }),
  meta: updateMetaSchema,
})

const rmPropDeep = (data: any, propToDelete = '__typename'): any => {
  if (typeof data !== 'object' || data === null) {
    return data
  }

  if (Array.isArray(data)) {
    return data.map(item => rmPropDeep(item, propToDelete))
  }

  const newObj: any = {}
  for (const key in data) {
    if (key !== propToDelete) {
      newObj[key] = rmPropDeep(data[key], propToDelete)
    }
  }

  return newObj
}

export const dataSheetConfig = createFormConfig<
  UpdateDataSheetValidatorSchema,
  CreateOrUpdateBlockDataSheetMutation,
  BlockDataSheetInput,
  XcNwBlock_BlockDataSheetType_Fragment
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockDataSheetDocument,
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore FIX WITH REAL INPUT TYPES
  fieldMapper: ({data}) => ({
    rawItems: data.rawItems,
    config: data.config,
    sections: data.sections,
  }),
  validatorSchema: updateDataSheetValidatorSchema,
  customFormNode: <DataSheetForm />,
  getDefaultValues: (block) => ({
    data: {
      rawItems: JSON.stringify(block.rawItems, null, 2),
      config: JSON.stringify(rmPropDeep(block.config), null, 2),
      sections: JSON.stringify(rmPropDeep(block.sections), null, 2),
    },
    meta: {
      pullout: block.pullout,
      countryCodes: block.countryCodes,
    },
  }),
})
